/** Indexed viseme15 slot → morph name (Nudgyt Agent wire format). */
export const VISEME15_BLENDSHAPES = {
  0: 'viseme_sil',
  1: 'viseme_PP',
  2: 'viseme_FF',
  3: 'viseme_TH',
  4: 'viseme_DD',
  5: 'viseme_kk',
  6: 'viseme_CH',
  7: 'viseme_SS',
  8: 'viseme_nn',
  9: 'viseme_RR',
  10: 'viseme_aa',
  11: 'viseme_E',
  12: 'viseme_I',
  13: 'viseme_O',
  14: 'viseme_U'
};

/** Same index order as VISEME15_BLENDSHAPES; three Convai rigs use uppercase morph names. */
export const CONVAI_VISEME_BLENDSHAPES = {
  ...VISEME15_BLENDSHAPES,
  5: 'viseme_KK',
  8: 'viseme_NN',
  10: 'viseme_AA'
};

export const VISEME15_OPEN_VOWELS = [
  'viseme_aa',
  'viseme_E',
  'viseme_I',
  'viseme_O',
  'viseme_U'
];

export const VISEME15_CONSONANTS = Object.values(VISEME15_BLENDSHAPES).filter(
  (name) => name !== 'viseme_sil' && !VISEME15_OPEN_VOWELS.includes(name)
);

/**
 * Per-viseme mouth openness (Oculus viseme reference).
 * Used to derive a single averaged mouthOpen instead of per-viseme jaw shapes.
 */
export const VISEME15_OPENNESS = {
  viseme_sil: 0,
  viseme_PP: 0,
  viseme_FF: 0.15,
  viseme_TH: 0.3,
  viseme_DD: 0.3,
  viseme_kk: 0.35,
  viseme_CH: 0.3,
  viseme_SS: 0.15,
  viseme_nn: 0.2,
  viseme_RR: 0.3,
  viseme_aa: 1,
  viseme_E: 0.6,
  viseme_I: 0.45,
  viseme_O: 0.7,
  viseme_U: 0.4
};

export const VISEME15_MOUTH_OPEN_TARGET = 'mouthOpen';

/** ARKit mouth/jaw morphs lipsync clears so viseme_* shapes own the lips while talking. */
export const VISEME15_CONFLICT_TARGETS = [
  'jawOpen',
  'mouthClose',
  'tongueOut',
  'mouthFunnel',
  'mouthPucker',
  'mouthRollUpper',
  'mouthRollLower',
  'mouthShrugUpper',
  'mouthShrugLower',
  'mouthUpperUpLeft',
  'mouthUpperUpRight',
  'mouthLowerDownLeft',
  'mouthLowerDownRight',
  'mouthPressLeft',
  'mouthPressRight'
];

export const VISEME15_RESET_TARGETS = Object.values(VISEME15_BLENDSHAPES);

/** ARKit-52 order for Core facial arrays (MediaPipe Face Landmarker v2). */
export const ARKIT52_BLENDSHAPES = [
  'browDownLeft',
  'browDownRight',
  'browInnerUp',
  'browOuterUpLeft',
  'browOuterUpRight',
  'cheekPuff',
  'cheekSquintLeft',
  'cheekSquintRight',
  'eyeBlinkLeft',
  'eyeBlinkRight',
  'eyeLookDownLeft',
  'eyeLookDownRight',
  'eyeLookInLeft',
  'eyeLookInRight',
  'eyeLookOutLeft',
  'eyeLookOutRight',
  'eyeLookUpLeft',
  'eyeLookUpRight',
  'eyeSquintLeft',
  'eyeSquintRight',
  'eyeWideLeft',
  'eyeWideRight',
  'jawForward',
  'jawLeft',
  'jawOpen',
  'jawRight',
  'mouthClose',
  'mouthDimpleLeft',
  'mouthDimpleRight',
  'mouthFrownLeft',
  'mouthFrownRight',
  'mouthFunnel',
  'mouthLeft',
  'mouthLowerDownLeft',
  'mouthLowerDownRight',
  'mouthPressLeft',
  'mouthPressRight',
  'mouthPucker',
  'mouthRight',
  'mouthRollLower',
  'mouthRollUpper',
  'mouthShrugLower',
  'mouthShrugUpper',
  'mouthSmileLeft',
  'mouthSmileRight',
  'mouthStretchLeft',
  'mouthStretchRight',
  'mouthUpperUpLeft',
  'mouthUpperUpRight',
  'noseSneerLeft',
  'noseSneerRight',
  'tongueOut'
];
